<div
    class="driver-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"
        [header]="'Payment Verification Details' | translate"
        *ngIf="verification"
    >
        <div class="border-300 pt-2 flex flex-column">
            <div>
                <span class="font-small text-400 font-bold mb-4">{{
                    "CUSTOMER_DETAILS" | translate
                }}</span>
            </div>
            <hr />
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        verification.customer.customerName
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "CUSTOMER_NAME" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{ verification.customer.contactInfo.contactEmail }}
                    </span>
                    <span class="text-500 text-sm">{{
                        "EMAIL" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{
                            verification.customer.contactInfo
                                .contactMobileNumber
                        }}
                    </span>
                    <span class="text-500 text-sm">{{
                        "MOBILE_NUMBER" | translate
                    }}</span>
                </div>
            </div>
            <div class="mt-4 mb-3">
                <span class="font-small text-400 font-bold mb-4">{{
                    "VEHICLE_TO_COVER" | translate
                }}</span>
            </div>
            <p-table
                [value]="verification.orderItems"
                responsiveLayout="scroll"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{ "VRN" | translate }}</th>
                        <th>{{ "VEHICLE_MAKE" | translate }}</th>
                        <th>{{ "MODEL" | translate }}</th>
                        <th>{{ "CARRYING_CAPACITY" | translate }}</th>
                        <th>{{ "YEAR_OF_MANUFACTURE" | translate }}</th>
                        <th>{{ "Insurer" | translate }}</th>
                        <th>{{ "PACKAGE" | translate }}</th>
                        <th>{{ "Premium Due" | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-orderItem>
                    <tr>
                        <td>
                            <span class="p-column-title"
                                >Vehicle Registration</span
                            >
                            {{ orderItem.registrationNumber }}
                        </td>
                        <td>
                            <span class="p-column-title">Make</span>
                            {{ orderItem.vehicleMake }}
                        </td>
                        <td>
                            <span class="p-column-title">Model</span>
                            {{ orderItem.vehicleModel }}
                        </td>
                        <td>
                            <span class="p-column-title"
                                >Carrying Capacity</span
                            >
                            {{ orderItem.carryingCapacity }}
                        </td>
                        <td>
                            <span class="p-column-title"
                                >Year of Manufacture</span
                            >
                            {{ orderItem.yearOfManufacture }}
                        </td>
                        <td>
                            <span class="p-column-title">Insurer</span>
                            {{ orderItem.providerName }}
                        </td>
                        <td>
                            <span class="p-column-title">Package</span>
                            {{ orderItem.packageName | translate }}
                        </td>
                        <td>
                            <span class="p-column-title">Premium Due</span>
                            {{ orderItem.premiumDue | currency : "MZN" + " " }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="flex w-full flex-wrap"></div>
            <div class="mt-6">
                <span class="font-small text-400 font-bold mb-4">{{
                    "PAYMENT DETAILS" | translate
                }}</span>
            </div>
            <hr />
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        verification.payment.reference
                            ? verification.payment.reference
                            : "---"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "PAYMENT_REFERENCE" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        verification.orderDate | date : "medium"
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "ORDER_DATE" | translate
                    }}</span>
                </div>
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        verification.total | currency : "MZN" + " "
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "TOTAL_AMOUNT" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        verification.payment.paymentMethod | camelCase
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "Mode of Payment" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        formatText(verification.status) | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "STATUS" | translate
                    }}</span>
                </div>
            </div>
            <div class="mt-4">
                <span class="font-small text-400 font-bold mb-4">{{
                    "PROOF_OF_PAYMENT" | translate
                }}</span>
            </div>
            <iframe
                *ngIf="
                    blobUrl &&
                    verification.proofOfPayment.mimeType === 'application/pdf'
                "
                [src]="blobUrl"
                [title]="verification.proofOfPayment.originalFileName"
                style="width: 80%"
                height="900"
                class="my-4"
            ></iframe>
            <img
                *ngIf="
                    blobUrl &&
                    verification.proofOfPayment.mimeType === 'image/png'
                "
                [src]="blobUrl"
                style="width: 80%; border: 3px solid gray"
                height="900"
                class="my-4"
                alt="Rendered Blob"
            />
            <img
                *ngIf="
                    blobUrl &&
                    verification.proofOfPayment.mimeType === 'image/jpeg'
                "
                [src]="blobUrl"
                style="width: 80%; border: 3px solid gray"
                height="900"
                class="my-4"
                alt="Rendered Blob"
            />
            <div *ngIf="loadingPOP" class="my-4">
                <span>Loading POP ...</span>
            </div>
        </div>
        <div class="flex gap-3">
            <p-button
                icon="pi pi-arrow-left"
                [label]="'Back' | translate"
                severity="primary"
                (onClick)="closePage()"
            />
            <p-button
                icon="pi pi-times-circle"
                [label]="'REJECT' | translate"
                severity="danger"
                (onClick)="showConfirmDialog(verification, 'REJECTED')"
            />
            <p-button
                icon="pi pi-verified"
                [label]="'APPROVE' | translate"
                severity="success"
                (onClick)="showConfirmDialog(verification, 'APPROVE')"
            />
            <p-button
                icon="pi pi-download"
                [label]="'DOWNLOAD' | translate"
                severity="success"
                (onClick)="downloadPop()"
            />
        </div>
    </p-card>
</div>
